import React, { useState, useRef, useEffect } from "react";
import { IconSearch, IconChevronDown, IconChevronUp, IconMapPin } from "@tabler/icons-react";
import { map } from "lodash";
import { HeatMapPolygon } from "../../models/heatMapModel";

interface Props {
  zones?: Pick<HeatMapPolygon, "id" | "name" | "ppm2_sale">[];
  onSelect?: (zone: Pick<HeatMapPolygon, "id" | "name">) => void;
}

const SearchZone: React.FC<Props> = ({ zones, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  // Cierra al hacer click fuera del componente
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div ref={ref} className="flex flex-col">
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 text-gray-400 w-full"
      >
        <IconSearch size={16} />
        <span className={`flex-1 text-sm text-left ${selected ? "text-gray-700" : ""}`}>
          {selected ?? "Buscar por zona"}
        </span>
        {open ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
      </button>

      {/* Lista expandible — max-height animada para desplazar contenido sin flotar */}
      <div className={`overflow-x-hidden bg-white rounded-xl overflow-y-auto transition-all duration-300 ease-in-out ${open ? "max-h-96 mt-2" : "max-h-0"}`}>
        {map(zones, (zone) => (
          <div
            key={zone.id}
            className="flex items-center gap-2 md:gap-3 px-2 md:px-4 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-0"
            onClick={() => { setSelected(zone.name); setOpen(false); onSelect?.(zone); }}
          >
            <div className="w-8 h-8 rounded-lg bg-[#05EE84]/20 flex items-center justify-center shrink-0">
              <IconMapPin size={16} className="text-[#05EE84]" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900 leading-none">{zone.name}</p>
              <p className="text-xs text-gray-500 mt-1">{zone.ppm2_sale != null ? `$${zone.ppm2_sale.toLocaleString()}/m²` : "—"}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchZone;
